import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('bg-card border border-border rounded-[14px]', className)} {...props} />
  );
}

export function CardInner({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('border border-border rounded-xl', className)} {...props} />;
}
